<template>
  <div class="inside-infobox container height48 displayF">
    <el-breadcrumb separator-class="el-icon-arrow-right" separator=">>" class="breadcrumb">
        <el-breadcrumb-item v-for="(item,i) in breadcrumbs" :key="i" :to="{ path: item.path }">{{item.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="inside-menu">
    <div v-for="(item,i) in button" :key="i">
      <a :href="item.url"  class="a">{{item.name}}</a>
    </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  props: {
    breadcrumbs: Array,
    button: Array,
  },
}
</script>

<style scoped>
.inside-infobox {
  background: #ef801a;
  display: flex;
  align-items: center;
}

.container {
  margin: 0 auto;
  position: relative;
}
.inside-menu {
  width: 60%;
  float: right;
  text-align: right;
  font-size: 16px;
  display: flex;
}

.a{
  color: #fff;
  height: 48px;
  padding: 0 40px;
  vertical-align: top;
  overflow: hidden;
  line-height: 48px;
  display: inline-block;
  position: relative;
  font-size: 18px;
  text-decoration: none;
}
.height48 {
  height: 48px;
}

/* 修改面包屑文本颜色为白色 */
::v-deep .el-breadcrumb__inner,
::v-deep .el-breadcrumb__inner a,
::v-deep .el-breadcrumb__inner.is-link {
  color: white !important;
}

/* 修改分隔符颜色为白色 */
::v-deep .el-breadcrumb__separator {
  color: white !important;
}

/* 鼠标悬停时的颜色（可选） */
::v-deep .el-breadcrumb__inner a:hover {
  color: #f0f0f0 !important; /* 稍微淡一点的白色 */
}

::v-deep .el-breadcrumb {
  line-height: 1;
  margin-left: 20%;
}

::v-deep .el-breadcrumb__item {
  font-size: 14px;
}

.breadcrumb {
  width: 100%;
}
</style>